import React, { useCallback, useState, useEffect } from 'react';
import {
  SaveButton,
  DeleteButton,
  Toolbar,
  useCreate,
  useUpdate,
  useRedirect,
} from 'react-admin';
import ProgressBar from '../progress-bar';
import { useUpload } from '../../helpers/aws';

const ResourceToolbar = (props) => {
  const { basePath, record, resourceName } = props;

  const action = record && record.id ? 'update' : 'create';

  const [create] = useCreate(resourceName);
  const [update] = useUpdate(resourceName, record.id);
  const redirectTo = useRedirect();

  const [formValues, setFormValues] = useState({});
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);
  const [success, setSuccess] = useState(null);
  const [response, setResponse] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [path, setPath] = useState(null);
  const [newRecord, setNewRecord] = useState(null);
  const [saved, setSaved] = useState(false);

  const [save] = useUpdate(resourceName, newRecord ? newRecord.id : undefined);

  useUpload(file, path, setSuccess, setProgress, setResponse, setUploading);

  useEffect(() => {
    if (formValues && Object.keys(formValues).length > 0) {
      if (!saved && !saving) {
        if (action === 'create') {
          if (file) {
            if (!path) {
              setSaving(true);
              create(
                {
                  payload: { data: { ...formValues } },
                },
                {
                  onSuccess: ({ data }) => {
                    setPath(`${resourceName}/${data.id}/`);
                    setSaving(false);
                    setNewRecord(data);
                  },
                }
              );
            } else {
              if (success && response && newRecord) {
                setSaving(true);
                save(
                  {
                    payload: { data: { ...formValues, ...response }, previousData: { ...newRecord } },
                  },
                  {
                    onSuccess: ({ data }) => {
                      setSaved(true);
                      setSaving(false);
                      redirectTo('edit', basePath, data.id, data);
                    },
                  }
                );  
              }
            }
          } else {
            setSaving(true);
            create(
              {
                payload: { data: { ...formValues } },
              },
              {
                onSuccess: ({ data }) => {
                  setSaved(true);
                  setSaving(false);
                  redirectTo('edit', basePath, data.id, data);
                },
              }
            );
          }
        } else if (action === 'update') {
          if (file) {
            setPath(`${resourceName}/${record.id}/`);
            if (success && response) {
              setSaving(true);
              update(
                {
                  payload: { data: { ...formValues, ...response }, previousData: { ...record } },
                },
                {
                  onSuccess: ({ data }) => {
                    setSaved(true);
                    setSaving(false);
                    redirectTo('list', basePath);
                  },
                }
              );  
            }
          } else {
            setSaving(true);
            update(
              {
                payload: { data: { ...formValues }, previousData: { ...record } },
              },
              {
                onSuccess: ({ data }) => {
                  setSaved(true);
                  setSaving(false);
                  redirectTo('list', basePath);
                },
              }
            );
          }
        }
      }
    }

  }, [action, record, basePath, create, update, redirectTo, formValues, file, progress, success, response, newRecord, resourceName, save, path, saved, saving]);

  const handleSave = useCallback(
    (values) => {
      const formValues = { ...values };
      delete formValues.files;
      setFormValues(formValues);
      const file = !!values.files && Object.keys(values.files).length > 0 && values.files.rawFile;
      if (file)
        setFile(file);
    }, []);
  // Filtrer les props qui ne doivent pas être passés au composant Toolbar de react-admin
  const toolbarProps = { ...props };
  delete toolbarProps.resourceName;
  delete toolbarProps.mutationMode;
  delete toolbarProps.validating;
  
  return (
    <>
      <ProgressBar uploading={uploading} saving={saving} progress={progress} />
      <Toolbar {...toolbarProps} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <SaveButton {...toolbarProps} onSave={handleSave} label="Save" disabled={props.pristine} />;
        { action === 'update' && <DeleteButton undoable={false} /> }
      </Toolbar>
    </>
  );
};

export default ResourceToolbar;
